'use client'

import { AcademicCapIcon, BurgerIcon, CalendarIcon, CurrencyEuroIcon, HomeIcon, UserGroupIcon, UserIcon, RocketLaunchIcon, DocumentChartIcon,EnvelopeIcon } from "@components/icons";
import { NavbarItem } from "@components/navbar";
import { CustomDropdown, DefaultLogo } from "@components/utilities";
import { useFetch } from "@hooks";
import { Avatar, DropdownItem } from "@nextui-org/react";
import { useLocalStore } from "@store/useLocalStore";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";

export function Navbar() {

    const userToken = useLocalStore(state => state.user.token);
    const userRole = useLocalStore(state => state.user.role);
    const pathname = usePathname();

    const [isOpen, setIsOpen] = useState(false);
    const [userData, userError, userLoading] = useFetch(userToken && `${process.env.SERVER_ADRESS}/users/profil`);
    const userLogo = userData?.profil?.logo ? userRole === "pros" ? `${userData?.profil?.logo}` : `${process.env.DEFAULT_LOGO}` : null;
    const iconClasses = "size-7 group-hover:stroke-[1.8]";

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const itemsArray = userRole === "pros" ?
        [
            { icon: <UserIcon className={iconClasses} color="#fff" />, desc: "Clients", src: "/pro/clients" },
            { icon: <UserGroupIcon className={iconClasses} color="#fff" />, desc: "Groupes", src: "/pro/groupes" },
            { icon: <AcademicCapIcon className={iconClasses} color="#fff" />, desc: "Formations", src: "/pro/formations" },
            { icon: <CalendarIcon className={iconClasses} color="#fff" />, desc: "Calendrier", src: "/pro/calendrier" },
            { icon: <DocumentChartIcon className={iconClasses} color="#fff" />, desc: "Formulaires", src: "/pro/formulaire" },
            { icon: <CurrencyEuroIcon className={iconClasses} color="#fff" />, desc: "Facturation", src: "/pro/facturation/recapitulatif" },
            { icon: <RocketLaunchIcon className={iconClasses} color="#fff" />, desc: "Tunnels", src: "/pro/onboarding" },
            { icon: <EnvelopeIcon className={iconClasses} color="#fff" />, desc: "Emailing", src: "/pro/emailing/tags" },
        ]
        :
        userRole === "client" ?
            [
                { icon: <UserIcon className={iconClasses} color="#fff" />, desc: "Individuels", src: "/particulier/accompagnements-individuel" },
                { icon: <UserGroupIcon className={iconClasses} color="#fff" />, desc: "Groupes", src: "/particulier/accompagnements-groupe" },
                { icon: <AcademicCapIcon className={iconClasses} color="#fff" />, desc: "Formations", src: "/particulier/mes-formations" },
                { icon: <CalendarIcon className={iconClasses} color="#fff" />, desc: "Calendrier", src: "/particulier/mon-espace/mes-rdv" },
            ]
            :
            []
        ;

    const homeElement = userRole === "pros"
        ?
        <NavbarItem icon={<HomeIcon className={iconClasses} color="#fff" />} desc="Mon espace" descSize={"text-sm"} descColor="text-white" src="/pro/mon-espace" currentLocation={pathname} />
        :
        userRole === "client" ?
            <NavbarItem icon={<HomeIcon className={iconClasses} color="#fff" />} desc="Mon espace" descSize={"text-sm"} descColor="text-white" src="/particulier/mon-espace" currentLocation={pathname} />
            :
            null

    const itemsElements = itemsArray.map((item, index) => {
        const { icon, desc, src } = item;
        return (
            <NavbarItem key={index} icon={icon} desc={desc} src={src} descSize={"text-sm"} descColor="text-white" currentLocation={pathname} />
        )
    });

    const dropdownElements = itemsElements.map((item, index) => <DropdownItem key={index} className="rounded-none border-b border-white/40 last:border-b-0" onPress={() => setIsOpen(false)}>{item}</DropdownItem>);
    dropdownElements.push(<DropdownItem key={itemsElements.length} onPress={() => setIsOpen(false)}>{homeElement}</DropdownItem>);

    return (
        userToken && (pathname.startsWith('/pro') || userToken && pathname.startsWith('/particulier'))
            ?
            <nav className="relative flex h-20 items-center justify-between rounded-b-lg bg-gradient-to-r from-secondaryBg via-primaryBg to-secondaryBg p-3 lg:fixed lg:left-0 lg:top-0 lg:h-screen lg:w-24 lg:min-w-24 lg:flex-col lg:overflow-y-auto lg:rounded-l-none lg:rounded-r-lg lg:bg-gradient-to-t lg:p-0 lg:pt-3 ">
                <Link href="/" className="mr-12 flex cursor-pointer justify-center lg:mb-10 lg:mr-0 lg:mt-2">
                    {userLogo
                        ?
                        <Avatar
                            src={`${userLogo ? `${process.env.PUBLIC_AMAZON}${userLogo}` : ""}`}
                            className="!size-14 cursor-pointer bg-transparent lg:!size-16"
                            alt="Logo"
                            fallback={<DefaultLogo />}
                            showFallback
                        />
                        :
                        <div className="size-16"></div>
                    }
                </Link>
                <div className="hidden w-full justify-evenly sm:flex lg:h-full lg:flex-col lg:items-center lg:justify-evenly">
                    {itemsElements}
                </div>

                <div className="ml-12 hidden sm:block lg:ml-0 lg:mt-8">
                    {homeElement}
                </div>

                <div className="sm:hidden">
                    <CustomDropdown
                        triggerElementContent={<BurgerIcon className={"size-7"} />}
                        dropdownElements={dropdownElements}
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                        toggleDropdown={toggleDropdown}
                    />
                </div>
            </nav>
            :
            null
    )
}
